<template>
  <div class="text-center mt-4 pb-4">
    <div class="icon-group">
      <i
        :key="iconKey"
        :class="iconClass"
      />
      <span class="ml-2">
        {{ message ?? $t('dataTable.noResultsFound') }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsNoData',
  props: {
    message: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: `fa-folder-times`,
    },
  },

  data() {
    return {
      iconKey: 0 as number,
    };
  },

  computed: {
    iconClass(): string {
      return `fal ${this.icon} fa-1x`;
    },
  },

  watch: {
    icon(): void {
      this.iconKey += 1;
    },
  },
});
</script>

<style lang="scss">
  .icon-group {
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgba(134, 148, 179, .5);
    font-weight: 600;
    i {
      font-weight: 500;
    }
  }
</style>
